export default {
    activityReport: {
        title: 'Activity Report',
        description:
            'Unique members who opened Chill Anywhere and unique members who meditated (a practice of at least 30 seconds) within the selected period.',
        filters: {
            business: 'Business',
            allBusinesses: 'All businesses',
            dateFrom: 'Date from',
            dateTo: 'Date to'
        },
        presets: {
            last7: 'Last 7 days',
            last30: 'Last 30 days',
            thisMonth: 'This month',
            lastMonth: 'Last month'
        },
        actions: {
            generate: 'Generate report',
            exportCsv: 'Export CSV',
            exportPdf: 'Export PDF'
        },
        stale: 'Filters changed – generate to refresh the report.',
        generatedAt: 'Generated {time}',
        noActivity:
            'No logins or practices were recorded for {scope} between {from} and {to}.',
        chart: {
            title: 'Daily trend'
        },
        summary: {
            members: 'Members',
            membersHint: 'Active members of the selected business',
            uniqueLogins: 'Unique logins',
            uniqueLoginsHint: 'Distinct users who opened the app at least once',
            uniqueMeditated: 'Unique meditated',
            uniqueMeditatedHint:
                'Distinct users with at least one practice of 30+ seconds',
            meditatedRate: 'Meditated of logged in',
            meditatedRateHint:
                'Share of users who logged in and also meditated',
            ofMembers: '{rate} of members',
            noLogins: 'No logins in this period',
            peakDay: 'Peak day',
            peakDayHint: '{count} unique logins',
            noPeak: 'No activity'
        },
        table: {
            title: 'Daily breakdown',
            date: 'Date',
            uniqueLogins: 'Unique logins',
            uniqueMeditated: 'Unique meditated',
            rowsPerPage: 'Days per page',
            all: 'All',
            hideEmptyDays: 'Hide days without activity',
            emptyDaysHidden: 'Days without activity hidden: {count}',
            allDaysEmpty: 'Every day in this range is empty.'
        },
        empty: 'Pick a business and a date range, then generate the report.',
        errors: {
            invalidRange: '"Date from" must not be after "Date to".',
            failed: 'Could not load the activity report. Please try again.'
        },
        neverLoggedIn: {
            action: 'Never logged in (CSV)',
            hint:
                'All-time list of active members who have never signed in. Uses the business filter, ignores the dates.',
            downloaded:
                '{count} member has never logged in — CSV downloaded | {count} members have never logged in — CSV downloaded',
            noneFound: 'No active members who have never logged in',
            failed:
                'Could not load members who never logged in. Please try again.',
            columns: {
                fullName: 'Full name',
                email: 'Email'
            }
        },
        report: {
            appName: 'Chill Anywhere',
            title: 'Activity Report',
            business: 'Business',
            allBusinesses: 'All businesses',
            period: 'Period',
            generated: 'Generated',
            metric: 'Metric',
            value: 'Value',
            totals: 'Totals',
            daily: 'Daily breakdown',
            page: 'Page {page} of {pages}',
            notAvailable: 'n/a',
            loginRate: 'Login rate (of members)',
            meditatedShare: 'Meditated (of members)',
            activeDays: 'Days with activity',
            weekly: 'Weekly figures',
            week: 'Week',
            loginDays: 'Login-days',
            maxLogins: 'Max logins / day',
            meditatedDays: 'Practice-days',
            maxMeditated: 'Max meditated / day',
            uniqueUsers: 'unique users'
        }
    }
};
